import clsx from 'clsx'
import Sheet from 'components/utils/Sheet'
import useCurrentLoyaltyTier from 'loyalty/hooks/useCurrentLoyaltyTier'
import styled from 'styled-components'

const BackgroundFrame = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
  overflow: hidden;
  pointer-events: none;
`

const TierBackgroundFrame = styled.div`
  position: absolute;
  inset: 0;
  overflow: hidden;
  container-type: size;
`

const TierBackground = styled(Sheet)`
  position: absolute;
  top: 50%;
  /* oxlint-disable-next-line logical-css/no-physical-properties */
  left: 50%;
  width: 100cqh;
  height: 100cqw;
  transform: translate(-50%, -50%) rotate(90deg);
  transform-origin: center;

`

interface Props {
  className?: string
}

function TriplePointTakeoverBackground(props: Props) {
  const { className } = props
  const [tier] = useCurrentLoyaltyTier()

  return <BackgroundFrame className={clsx(className, tier)} data-testid="triple-points-background">
    <TierBackgroundFrame data-testid="triple-points-tier-background-frame">
      <TierBackground
        background={`tier-${tier}-primary`}
        className={tier}
        data-testid="triple-points-tier-background"
        paletteType="default"
      />
    </TierBackgroundFrame>
  </BackgroundFrame>
}

export default TriplePointTakeoverBackground
